import type { PlatformRole } from '@/models/auth';

export function isPlatformAdminRole(role?: PlatformRole | null): role is 'platform_admin' {
  return role === 'platform_admin';
}

export function getAdminRoleLabel(role?: PlatformRole | null): string {
  return isPlatformAdminRole(role) ? 'Platform Admin' : 'Organization Admin';
}

export function getManagedOrganizationLabel(
  role?: PlatformRole | null,
  options: { plural?: boolean; lowercase?: boolean } = {},
): string {
  const { plural = false, lowercase = false } = options;
  const label = isPlatformAdminRole(role)
    ? (plural ? 'Organizations' : 'Organization')
    : (plural ? 'Clients' : 'Client');

  return lowercase ? label.toLowerCase() : label;
}

export function getOperatingScopeLabel(role?: PlatformRole | null): string {
  return isPlatformAdminRole(role) ? 'Platform' : 'Organization';
}
